'use strict';

var _classCallCheck = require("/home/jfontirroig/pact/dappcrosscheck/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/jfontirroig/pact/dappcrosscheck/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, '__esModule', {
  value: true
});

var combiner_1 = require('./combiner');

var parser_1 = require('./parser');

var typeFields_1 = require('./typeFields');

var utils_1 = require('./utils');

var Psbt =
/*#__PURE__*/
function () {
  function Psbt(tx) {
    _classCallCheck(this, Psbt);

    this.inputs = [];
    this.outputs = [];
    this.globalMap = {
      unsignedTx: tx
    };
  }

  _createClass(Psbt, [{
    key: "toBase64",
    value: function toBase64() {
      var buffer = this.toBuffer();
      return buffer.toString('base64');
    }
  }, {
    key: "toHex",
    value: function toHex() {
      var buffer = this.toBuffer();
      return buffer.toString('hex');
    }
  }, {
    key: "toBuffer",
    value: function toBuffer() {
      return parser_1.psbtToBuffer(this);
    }
  }, {
    key: "updateGlobal",
    value: function updateGlobal(updateData) {
      utils_1.updateGlobal(updateData, this.globalMap);
      return this;
    }
  }, {
    key: "updateInput",
    value: function updateInput(inputIndex, updateData) {
      var input = utils_1.checkForInput(this.inputs, inputIndex);
      utils_1.updateInput(updateData, input);
      return this;
    }
  }, {
    key: "updateOutput",
    value: function updateOutput(outputIndex, updateData) {
      var output = utils_1.checkForOutput(this.outputs, outputIndex);
      utils_1.updateOutput(updateData, output);
      return this;
    }
  }, {
    key: "addUnknownKeyValToGlobal",
    value: function addUnknownKeyValToGlobal(keyVal) {
      utils_1.checkHasKey(keyVal, this.globalMap.unknownKeyVals, utils_1.getEnumLength(typeFields_1.GlobalTypes));
      if (!this.globalMap.unknownKeyVals) this.globalMap.unknownKeyVals = [];
      this.globalMap.unknownKeyVals.push(keyVal);
      return this;
    }
  }, {
    key: "addUnknownKeyValToInput",
    value: function addUnknownKeyValToInput(inputIndex, keyVal) {
      var input = utils_1.checkForInput(this.inputs, inputIndex);
      utils_1.checkHasKey(keyVal, input.unknownKeyVals, utils_1.getEnumLength(typeFields_1.InputTypes));
      if (!input.unknownKeyVals) input.unknownKeyVals = [];
      input.unknownKeyVals.push(keyVal);
      return this;
    }
  }, {
    key: "addUnknownKeyValToOutput",
    value: function addUnknownKeyValToOutput(outputIndex, keyVal) {
      var output = utils_1.checkForOutput(this.outputs, outputIndex);
      utils_1.checkHasKey(keyVal, output.unknownKeyVals, utils_1.getEnumLength(typeFields_1.OutputTypes));
      if (!output.unknownKeyVals) output.unknownKeyVals = [];
      output.unknownKeyVals.push(keyVal);
      return this;
    }
  }, {
    key: "addInput",
    value: function addInput(inputData) {
      var _this = this;

      this.globalMap.unsignedTx.addInput(inputData);
      this.inputs.push({
        unknownKeyVals: []
      });
      var addKeyVals = inputData.unknownKeyVals || [];
      var inputIndex = this.inputs.length - 1;

      if (!Array.isArray(addKeyVals)) {
        throw new Error('unknownKeyVals must be an Array');
      }

      addKeyVals.forEach(function (keyVal) {
        return _this.addUnknownKeyValToInput(inputIndex, keyVal);
      });
      utils_1.addInputAttributes(this.inputs, inputData);
      return this;
    }
  }, {
    key: "addOutput",
    value: function addOutput(outputData) {
      var _this2 = this;

      this.globalMap.unsignedTx.addOutput(outputData);
      this.outputs.push({
        unknownKeyVals: []
      });
      var addKeyVals = outputData.unknownKeyVals || [];
      var outputIndex = this.outputs.length - 1;

      if (!Array.isArray(addKeyVals)) {
        throw new Error('unknownKeyVals must be an Array');
      }

      addKeyVals.forEach(function (keyVal) {
        return _this2.addUnknownKeyValToInput(outputIndex, keyVal);
      });
      utils_1.addOutputAttributes(this.outputs, outputData);
      return this;
    }
  }, {
    key: "clearFinalizedInput",
    value: function clearFinalizedInput(inputIndex) {
      var input = utils_1.checkForInput(this.inputs, inputIndex);
      utils_1.inputCheckUncleanFinalized(inputIndex, input);

      for (var _i = 0, _Object$keys = Object.keys(input); _i < _Object$keys.length; _i++) {
        var key = _Object$keys[_i];

        if (!['witnessUtxo', 'nonWitnessUtxo', 'finalScriptSig', 'finalScriptWitness', 'unknownKeyVals'].includes(key)) {
          // @ts-ignore
          delete input[key];
        }
      }

      return this;
    }
  }, {
    key: "combine",
    value: function combine() {
      for (var _len = arguments.length, those = new Array(_len), _key = 0; _key < _len; _key++) {
        those[_key] = arguments[_key];
      }

      // Combine this with those.
      // Return self for chaining.
      var result = combiner_1.combine([this].concat(those));
      Object.assign(this, result);
      return this;
    }
  }, {
    key: "getTransaction",
    value: function getTransaction() {
      return this.globalMap.unsignedTx.toBuffer();
    }
  }], [{
    key: "fromBase64",
    value: function fromBase64(data, txFromBuffer) {
      var buffer = Buffer.from(data, 'base64');
      return this.fromBuffer(buffer, txFromBuffer);
    }
  }, {
    key: "fromHex",
    value: function fromHex(data, txFromBuffer) {
      var buffer = Buffer.from(data, 'hex');
      return this.fromBuffer(buffer, txFromBuffer);
    }
  }, {
    key: "fromBuffer",
    value: function fromBuffer(buffer, txFromBuffer) {
      var results = parser_1.psbtFromBuffer(buffer, txFromBuffer);
      var psbt = new this(results.globalMap.unsignedTx);
      Object.assign(psbt, results);
      return psbt;
    }
  }]);

  return Psbt;
}();

exports.Psbt = Psbt;